import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccentWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8144 13.1335L16.8136 13.132L10.6644 2.4542C10.6643 2.45411 10.6643 2.45403 10.6642 2.45394C10.6642 2.45385 10.6641 2.45377 10.6641 2.45368C9.93262 1.18211 8.06922 1.18211 7.33779 2.45368C7.33769 2.45386 7.33759 2.45403 7.33749 2.4542L1.18826 13.132L1.18742 13.1335C0.453881 14.4139 1.42046 15.9375 2.85139 15.9375H15.1505C16.5814 15.9375 17.548 14.4139 16.8144 13.1335Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 10.125V7.3125",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 13.5C9.46599 13.5 9.84375 13.1222 9.84375 12.6562C9.84375 12.1903 9.46599 11.8125 9 11.8125C8.53401 11.8125 8.15625 12.1903 8.15625 12.6562C8.15625 13.1222 8.53401 13.5 9 13.5Z",
			fill: "white"
		})
	]
});
export default SvgAccentWarning;
